import React, { Component } from 'react';

import apiUtil from '../../../../api/apiUtil.jsx';
import AuditTrailApi from '../../../../api/OLD/Dispatch/AuditTrail.jsx';

import { 
    Box,
    Divider,
    LinearProgress,
} from '@material-ui/core';

import { 
    Button,
} from "react-bootstrap-v5";

import Pagination from '@material-ui/lab/Pagination';

import ManageLabel from '../../../../components/OLD/input/ManageLabel.jsx';
import AuditTrailTimeline from "../../../../components/OLD/Timeline/AuditTrailTimeline.jsx";
import AuditTrailDetails from "./AuditTrailDetails.jsx";


class AuditTrailList extends Component {
  
    constructor(props){
        super(props);
        
        let isLoading = ((props.isLoading === false) || (props.isLoading === true)) ? props.isLoading : false;
        let items = (props.items && props.items.length > 0) ? props.items : [];
        let objectId = (props.objectId) ? props.objectId : null;
        let auditTrailObjectType = (props.auditTrailObjectType) ? props.auditTrailObjectType : null;
        let title = (props.title && props.title !== '') ? props.title : '';
        
        this.state = {
            isLoading: isLoading,
            items: items,
            objectId: objectId,
            auditTrailObjectType: auditTrailObjectType,
            title: title,
        }
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.isLoading !== this.state.isLoading) {
            let isLoading = ((nextProps.isLoading === false) || (nextProps.isLoading === true)) ? nextProps.isLoading : false;
			this.setState({
				isLoading: isLoading
			});
		}

		if (nextProps.items !== this.state.items) {
            let items = (nextProps.items && nextProps.items.length > 0) ? nextProps.items : [];
			this.setState({
				items: items
			});
        }

        if (nextProps.objectId !== this.state.objectId) {
            let objectId = (nextProps.objectId) ? nextProps.objectId : null;
			this.setState({
				objectId: objectId
			});
        }

        if (nextProps.auditTrailObjectType !== this.state.auditTrailObjectType) {
            let auditTrailObjectType = (nextProps.auditTrailObjectType) ? nextProps.auditTrailObjectType : null;
			this.setState({
				auditTrailObjectType: auditTrailObjectType
			});
        }

        if (nextProps.title !== this.state.title) {
            let title = (nextProps.title && nextProps.title !== '') ? nextProps.title : '';
			this.setState({
				title: title
			});
        }
	}


    /* API */
    callCompareAuditTrailApi = (auditTrailId, callback = null) => {
        let token = '';
        
        AuditTrailApi.compareAuditTrail(
            this.state.auditTrailObjectType, 
            this.state.objectId,
            auditTrailId,
            token
        ).then(result => {
            apiUtil.parseResult(result, (data) => {
                let currentVersion = (data && data.currentVersion) ? data.currentVersion : null;
                let previousVersion = (data && data.previousVersion) ? data.previousVersion : null;
                
                if(this.props.manageData){
                    this.props.manageData(currentVersion, previousVersion, (c, p) => {
                        currentVersion = (c) ? c : null;
                        previousVersion = (p) ? p : null;
                    });
                }

                if(callback){
                    callback(currentVersion, previousVersion);
                }
            }, (error, type) => {
                if(callback){
                    callback(null, null);
                }
            });
        });
    }
    /* END API */


    getDetails = (index, currentVersion, previousVersion) => {
        if(this.props.details){
            return <AuditTrailDetails
                index={index}
                currentVersion={currentVersion}
                previousVersion={previousVersion}
                details={this.props.details}
            />
        }
    }


    setTitle = () => {
        return <Box>
            <ManageLabel 
                label={(this.state.title !== '') ? this.state.title : 'Audit Trail'}
                size={'md'}
            />
        </Box>
    }

    setList = () => {
        return <Box pt={2}>
            <AuditTrailTimeline
                items={this.state.items}
                isLoading={this.state.isLoading}
                className={'min-width-120'}
                noResult={'No Audit Trail!'}
                isDetails={true}
                detailsBtnTextOpened={'Collapse Details'}
                detailsBtnTextClosed={'View Changes'}
                onChangeShowDetails={(index, showDetails) => {
                    let items = this.state.items;
                    if(items && items.length > 0 && index > -1){
                        items[index].showDetails = showDetails;
                        items[index].details = <LinearProgress />;
                        items[index].isLoadingDetails = showDetails;
            
                        this.setState({
                            items: items
                        }, () => {
                            if(showDetails){
                                this.callCompareAuditTrailApi(items[index].id, (currentVersion, previousVersion) => {
                                    let detailsMsg = <Box style={{ fontWeight: 'bold' }}>Audit trails is not recorded for old data!</Box>;

                                    let details = null;
                                    if(currentVersion){
                                        details = this.getDetails(index, currentVersion, previousVersion);
                                        if(details){
                                            items[index].details = details;
                                        } else {
                                            details = detailsMsg;
                                        }
                                    } else {
                                        details = detailsMsg;
                                    }
                    
                                    items[index].details = details;
                                    items[index].isLoadingDetails = false;
                    
                                    this.setState({
                                        items: items
                                    });
                                });
                            }
                        });
                    }
                }}
            />
        </Box>
    }

    setPagination = () => {
        if(this.state.items && this.state.items.length > 0){
            return <Box pb={2} textAlign={'center'}>
                <Pagination 
                    className={'v-center'}
                    count={apiUtil.getPaginationCount(this.props.totalRows, this.props.pageSize)} 
                    page={this.props.currentPage} 
                    size={'small'}
                    boundaryCount={2} 
                    showFirstButton
                    showLastButton
                    onChange={(event, value) => {
                        if(this.props.onChangePage){
                            this.props.onChangePage(value);
                        }
                    }}
                />
            </Box>
        }
    }

    setButton = () => {
        return <Box pt={2}>
            <Button 
                variant={'light'}
                onClick={() => {
                    if(this.props.onClose){
                        this.props.onClose()
                    }
                }}
            >
                Cancel
            </Button>
        </Box>
    }


    render() {
        return <Box>
            {this.setTitle()}
            <Divider />
            {this.setList()}
            {this.setPagination()}
            <Divider />
            {this.setButton()}
        </Box>
    }
}

export default AuditTrailList;
